import client from "../Client/HttpClient";
import { ITuitionPriceListsModel } from "@/interfaces/modules";

const ApiPath = "TuitionPriceLists";

export default {
    GetPriceLists: (): Promise<ITuitionPriceListsModel[]> => client.get(`${ApiPath}`),
    GetPriceListById: (data: ITuitionPriceListsModel): Promise<ITuitionPriceListsModel> => client.get(`${ApiPath}/${data.Id}`),
    PostPriceList: (data: ITuitionPriceListsModel): Promise<ITuitionPriceListsModel> => client.post(`${ApiPath}`, data),
};
